import { useEffect } from "react";

import * as DataWedgeApi from "@/modules/datawedge-api";
import * as Sentry from "@sentry/react-native";

let stack: ((ean: string) => void)[] = [];

export const useBarcodeScanner = (onScan: (ean: string) => void) => {
  useEffect(() => {
    stack.push(onScan);
    return () => {
      const index = stack.indexOf(onScan);
      if (index !== -1) {
        stack.splice(index, 1);
      }
    };
  }, [onScan]);

  installHandler();
};

let subscription: undefined | (() => void);
function installHandler() {
  subscription ??= DataWedgeApi.subscribeIntents(
    (intent: DataWedgeApi.Intent) => {
      if (intent.action === "android.intent.action.storesprint.BARCODE_SCAN") {
        const dataString = intent.extras?.["com.symbol.datawedge.data_string"];
        if (typeof dataString !== "string") return;

        const labelType = intent.extras?.["com.symbol.datawedge.label_type"];

        switch (labelType) {
          case "LABEL-TYPE-EAN8":
          case "LABEL-TYPE-EAN13":
          case "LABEL-TYPE-EAN128":
          case "LABEL-TYPE-UPCA":
          case "LABEL-TYPE-UPCE":
            stack[stack.length - 1]?.(dataString);
            break;

          default:
            Sentry.captureMessage(
              `Unknown/unsupported datawedge label-type: "${labelType}"`
            );
        }
      }
    }
  );
}
